export const loginUser = (payload: { username: string; password: string }) => {
  return async (dispatch: any) => {};
};

export const getUserDetails = () => {
  return async (dispatch: any) => {};
};

/** Refresh token */
export const refreshToken = async (
  url: string,
  callbackFun: Function,
  method?: "GET" | "POST",
  payload?: any
) => {};
